export default __webpack_public_path__ + "d44c92e6396e6fa8e2e8b4650d83eb1b.jpg";